import { DestroyRef, Directive, ElementRef, inject, input } from '@angular/core';
import { ConfigService } from '../../../core/services/config.service';
import { ConfirmService } from 'excellence-ui';
import { TranslocoService } from '@jsverse/transloco';
import { environment } from '../../../../environments/environment';

@Directive({
  selector: '[disableInDemoMode], [preventInDemoMode]',
})
export class DisableInDemoModeDirective {
  private elementRef = inject(ElementRef<HTMLElement>);
  private configService = inject(ConfigService);
  private confirmService = inject(ConfirmService);
  private translocoService = inject(TranslocoService);
  private destroyRef = inject(DestroyRef);

  disableInDemoMode = input<boolean | '' | unknown>(true);

  private isDialogOpen = false;

  constructor() {
    const element = this.elementRef.nativeElement;
    const handler = (event: MouseEvent) => this.handleClick(event);

    element.addEventListener('click', handler, true);
    this.destroyRef.onDestroy(() => {
      element.removeEventListener('click', handler, true);
    });
  }

  private handleClick(event: MouseEvent): void {
    if (!this.configService.isDemoMode() || this.disableInDemoMode() === false) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    void this.showWarningDialog();
  }

  private async showWarningDialog(): Promise<void> {
    if (this.isDialogOpen) {
      return;
    }

    this.isDialogOpen = true;
    try {
      const confirm = await this.confirmService.confirm({
        allowCancel: true,
        icon: 'heroExclamationCircle',
        title: this.translocoService.translate('demoMode.dialog.title'),
        message: this.translocoService.translate('demoMode.dialog.message'),
        confirmButtonText: this.translocoService.translate('demoMode.dialog.confirmButton'),
        cancelButtonText: this.translocoService.translate('demoMode.dialog.cancelButton'),
      });
      if (confirm) {
        window.open(environment.demo.registerLumoUrl, '_blank');
      }
      this.isDialogOpen = false;
    } finally {
      this.isDialogOpen = false;
    }
  }
}
